module.exports = __webpack_public_path__ + "img/full2-min.16f5e829.png";